export default __webpack_public_path__ + "static/media/add.1d68e63c.svg";